import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Bell, ExternalLink, LayoutDashboard, LogOut, Menu, Package, Search, ShoppingBag, Store, Users, X } from "lucide-react";
import { useAuth } from "../context/AuthContext";

const adminNavigation = [
  { to: "/admin", label: "Overview", icon: LayoutDashboard, end: true },
  { to: "/admin/orders", label: "Orders", icon: ShoppingBag },
  { to: "/admin/menu", label: "Products & inventory", icon: Package },
  { to: "/admin/customers", label: "Customers", icon: Users },
];

function DashboardShell({ title, subtitle, links = [], children }) {
  const { logout, user } = useAuth();
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [search, setSearch] = useState("");
  const isAdmin = user?.role === "admin";
  const navigation = isAdmin ? adminNavigation : links.map((link) => ({ ...link, icon: ShoppingBag, end: link.to === "/rider" }));
  const initials = user?.name?.split(" ").map((part) => part[0]).join("").slice(0, 2).toUpperCase() || "JG";

  const runSearch = (event) => {
    event.preventDefault();
    if (!search.trim()) return;
    navigate(`/admin/menu?search=${encodeURIComponent(search.trim())}`);
  };

  const signOut = async () => {
    await logout();
    navigate(isAdmin ? "/admin/login" : "/account");
  };

  return <div className="saas-admin">
    <aside className={mobileOpen ? "saas-sidebar open" : "saas-sidebar"}>
      <div className="saas-brand"><span>JG</span><div><strong>Jummy’s Global</strong><small>Commerce OS</small></div><button onClick={() => setMobileOpen(false)} aria-label="Close navigation"><X /></button></div>
      <div className="saas-store-status"><i /><span><strong>Store online</strong><small>All systems operational</small></span></div>
      <nav className="saas-nav"><small>Workspace</small>{navigation.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end} onClick={() => setMobileOpen(false)}><Icon /><span>{label}</span></NavLink>)}</nav>
      {isAdmin && <div className="saas-channel"><small>Sales channel</small><Link to="/" target="_blank"><Store /><span><strong>Online store</strong><em>Live storefront</em></span><ExternalLink /></Link></div>}
      <div className="saas-side-footer"><div className="saas-user"><span>{initials}</span><div><strong>{user?.name || "Administrator"}</strong><small>{user?.email || "Store owner"}</small></div></div><button onClick={signOut}><LogOut /> Sign out</button></div>
    </aside>
    {mobileOpen && <button className="saas-backdrop" aria-label="Close navigation" onClick={() => setMobileOpen(false)} />}
    <div className="saas-main">
      <header className="saas-topbar"><button className="saas-menu" onClick={() => setMobileOpen(true)} aria-label="Open navigation"><Menu /></button><form onSubmit={runSearch}><Search /><input value={search} onChange={(event) => setSearch(event.target.value)} placeholder="Search products and inventory" aria-label="Search admin" /><kbd>⌘ K</kbd></form><div className="saas-top-actions"><Link to="/" target="_blank">View store <ExternalLink /></Link><button aria-label="Notifications"><Bell /><i /></button><span>{initials}</span></div></header>
      <main className="saas-content"><div className="saas-page-context"><div><p>{isAdmin ? "Jummy’s Global / Admin" : "Jummy’s Global / Delivery"}</p><h1>{title}</h1><span>{subtitle}</span></div><div className="saas-live"><i /> Live data</div></div>{children}</main>
    </div>
  </div>;
}

export default DashboardShell;
